<!-- /src/components/modals/DetalharTurmaInstrutor.vue -->
<template>
  <Teleport to="body">
    <div class="modal-overlay" @click.self="$emit('fechar')">
      <div class="modal-container">
        <!-- Header -->
        <div class="modal-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            Detalhes da Turma:
            <span v-if="details">
              {{ details.turma_id }} | {{ details.dia_semana }} | {{ details.horario }} | {{ details.instrutor }}
            </span>
          </h5>
          <button class="btn btn-sm btn-secondary" @click="$emit('fechar')">Fechar</button>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <div v-if="turma" class="card card-body shadow-sm mt-0">
            <div class="form-content mt-2">
              <!-- Seção 1: Alunos -->
              <FormSection title="Alunos da Turma">
                <div class="alunos-sections">
                  <div v-if="matriculados.length">
                    <h6 class="table-title">Matriculados</h6>
                    <div class="modal-table-scroll">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Matrícula</th>
                            <th>Aluno</th>
                            <th>Responsável</th>
                            <th>Observações</th>
                            <th>Ação</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="aluno in matriculados" 
                            :key="
                              aluno.reposicao
                                ? `reposicao-${aluno.id}`
                                : `matricula-${aluno.matricula_id}`
                            "
                          >
                            <td>{{ aluno.matricula_id || 'Sem matrícula' }}</td>
                            <td>
                              {{ aluno.aluno_nome }}
                              <span v-if="aluno.reposicao" style="color: blue;"> (Reposição)</span>
                            </td>
                            <td>{{ aluno.responsavel_nome }}</td>
                            <td
                              :style="
                                aluno.observacao &&
                                (aluno.observacao.startsWith('Agendada para o dia') ||
                                 aluno.observacao.includes('Falta avisada'))
                                  ? 'color: red'
                                  : ''
                              "
                            >
                              {{ aluno.observacao || '' }}
                            </td>
                            <td>
                              <i
                                class="bi bi-eye text-primary mx-2"
                                style="cursor:pointer;"
                                title="Observações do aluno"
                                @click="abrirModalObservacoes(aluno)"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div v-if="experimentais.length" class="mt-3">
                    <h6 class="table-title experimental-title">Aula Experimental</h6>
                    <div class="modal-table-scroll">
                      <table class="table table-experimental">
                        <thead>
                          <tr>
                            <th>Aluno</th>
                            <th>Responsável</th>
                            <th>Observações</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="aluno in experimentais" :key="aluno.id">
                          <td>
                            {{ aluno.aluno_nome }}
                            <span v-if="aluno.idade !== null && aluno.idade !== undefined" class="text-muted">
                              ({{ aluno.idade }} {{ aluno.idade === 1 ? 'ano' : 'anos' }})
                            </span>
                          </td>
                            <td>{{ aluno.responsavel_nome }}</td>
                            <td
                              :style="
                                aluno.observacao &&
                                (aluno.observacao.startsWith('Agendada para o dia') ||
                                 aluno.observacao.includes('Falta avisada'))
                                  ? 'color: red'
                                  : ''
                              "
                            >
                              {{ aluno.observacao || aluno.observacoes || '' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div v-if="avulsos.length" class="mt-3">
                    <h6 class="table-title avulsas-title">Aula Avulsa</h6>
                    <div class="modal-table-scroll">
                      <table class="table table-avulsa">
                        <thead>
                          <tr>
                            <th>Aluno</th>
                            <th>Responsável</th>
                            <th>Observações</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="aluno in avulsos" :key="aluno.id">
                            <td>{{ aluno.aluno_nome }}</td>
                            <td>{{ aluno.responsavel_nome }}</td>
                            <td
                              :style="
                                aluno.observacao &&
                                (aluno.observacao.startsWith('Agendada para o dia') ||
                                 aluno.observacao.includes('Falta avisada'))
                                  ? 'color: red'
                                  : ''
                              "
                            >
                              {{ aluno.observacao || aluno.observacoes || '' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </FormSection>

              <!-- Seção 2: Chamadas realizadas -->
              <FormSection title="Chamadas Realizadas">
                <div class="table-responsive" style="max-height: 300px; overflow: auto;">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Data da aula</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(chamada, i) in chamadas" :key="chamada.id">
                        <td>{{ i + 1 }}</td>
                        <td>{{ globalUtils.formatarData(chamada.data_aula) }}</td>
                        <td>Realizada em {{ globalUtils.formatarData(chamada.data_registro) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </FormSection>
            </div>
          </div>

          <div v-else class="py-4 text-center">Carregando...</div>
        </div>

        <!-- Modal Observações do Aluno -->
        <AlunosObservacoes
          v-if="exibirModalObservacoes"
          :aluno="alunoSelecionado"
          :observacoes="observacoesAluno"
          @fechar="exibirModalObservacoes = false"
        />
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, watch } from 'vue';
import axios from '@/services/axios';
import globalUtils from '@/utils/globalUtils';
import FormSection from '@/components/Layout/FormSection.vue';
import AlunosObservacoes from '@/components/modals/AlunosObservacoes.vue';

const props = defineProps({
  id: { type: String, required: true }
});
const emit = defineEmits(['fechar']);

function parseUniqueId(uid) {
  if (typeof uid !== 'string') return null;
  const parts = uid.split('|');
  if (parts.length < 4) return null;

  const turma_id = parts[0];

  let dia_semana = parts[1] || '';
  const d = dia_semana.toLowerCase();
  if (d === 'terca-feira') dia_semana = 'terça-feira';
  if (d === 'sabado') dia_semana = 'sábado';

  const rawHorario = parts[2] || '';
  // Se vier "070000" vira "07:00:00". Se vier "0700" ou "10:00" mantém como está.
  const horario = rawHorario.length === 6
    ? `${rawHorario.slice(0,2)}:${rawHorario.slice(2,4)}:${rawHorario.slice(4,6)}`
    : rawHorario;

  const instrutor = decodeURIComponent(parts[3] || '');
  return { turma_id, dia_semana, horario, instrutor };
}

const details = ref(null);
const turma = ref(null);
const currentDate = ref(new Date().toISOString().split('T')[0]);
const matriculados = ref([]);
const experimentais = ref([]);
const avulsos = ref([]);
const chamadas = ref([]);

const exibirModalObservacoes = ref(false);
const observacoesAluno = ref(null);
const alunoSelecionado = ref(null);

async function abrirModalObservacoes(aluno) {
  alunoSelecionado.value = aluno;
  try {
    const { data } = await axios.get(`/operacional/alunos-observacoes`, {
      params: { matricula_id: aluno.matricula_id }
    });
    observacoesAluno.value = data;
    exibirModalObservacoes.value = true;
  } catch (e) {
    console.error('Erro ao carregar observações do aluno:', e);
  }
}


async function loadDadosChamada() {
  if (!details.value) return;

  /*
   * Concatena uma observação automática com uma observação já existente,
   * evitando separadores desnecessários.
   */
  const appendObs = (base, extra) => {
    const textoBase = String(base || '').trim();
    const textoExtra = String(extra || '').trim();

    if (!textoExtra) return textoBase;
    if (!textoBase) return textoExtra;

    return `${textoBase} - ${textoExtra}`;
  };

  /*
   * Normaliza datas recebidas como:
   * 2026-07-20
   * 2026-07-20T03:00:00.000Z
   *
   * Em ambos os casos retorna 2026-07-20.
   */
  const somenteData = (valor) => {
    if (!valor) return null;
    return String(valor).slice(0, 10);
  };

  const params = {
    data: currentDate.value,
    turma_id: details.value.turma_id,
    dia_semana: details.value.dia_semana,
    horario: details.value.horario
  };

  try {
    const resp = await axios.get(
      `/operacional/turmas-instrutor/detalhes`,
      { params }
    );

    turma.value = resp.data;

    const data = resp.data;
    const hoje = somenteData(currentDate.value);

    /* ======================
     * Matriculados
     * ====================== */
    const matriculadosData = (data.matriculados || []).map(aluno => ({
      ...aluno,
      presenca: aluno.presenca ?? true
    }));

    /* ======================
     * Reposição
     * ====================== */
    const reposicaoData = (data.reposicao || []).map(aluno => {
      const dataAula = somenteData(aluno.data_aula);

      let observacaoAutomatica = '';

      if (dataAula === hoje) {
        observacaoAutomatica = 'Agendada para hoje';
      } else if (dataAula && dataAula > hoje) {
        observacaoAutomatica =
          `Agendada para o dia ${globalUtils.formatarData(aluno.data_aula)}`;
      }

      return {
        ...aluno,
        presenca: aluno.presenca ?? true,
        reposicao: true,
        matricula: aluno.matricula_id || null,
        observacao: appendObs(
          observacaoAutomatica,
          aluno.observacao
        )
      };
    });

    matriculados.value = [
      ...matriculadosData,
      ...reposicaoData
    ];

    /* ======================
     * Experimentais
     * ====================== */
    experimentais.value = (data.experimentais || []).map(aluno => {
      const dataAula = somenteData(aluno.data_aula);
      const confirmada = aluno.status === 'Confirmada';

      let observacaoAutomatica = '';

      if (dataAula === hoje) {
        observacaoAutomatica = confirmada
          ? 'Confirmada para hoje'
          : 'Agendada para hoje';
      } else if (dataAula && dataAula > hoje) {
        const prefixo = confirmada
          ? 'Confirmada para o dia'
          : 'Agendada para o dia';

        observacaoAutomatica =
          `${prefixo} ${globalUtils.formatarData(aluno.data_aula)}`;
      } else {
        observacaoAutomatica = aluno.observacao || '';
      }

      return {
        ...aluno,
        presenca: aluno.presenca ?? true,
        observacao: appendObs(
          observacaoAutomatica,
          aluno.observacoes
        )
      };
    });

    /* ======================
     * Aulas avulsas
     * ====================== */
    avulsos.value = (data.avulsos || []).map(aluno => {
      const dataAula = somenteData(aluno.data_aula);

      let observacaoAutomatica = '';

      if (dataAula === hoje) {
        observacaoAutomatica = 'Agendada para hoje';
      } else if (dataAula && dataAula > hoje) {
        observacaoAutomatica =
          `Agendada para o dia ${globalUtils.formatarData(aluno.data_aula)}`;
      } else {
        observacaoAutomatica = aluno.observacao || '';
      }

      return {
        ...aluno,
        presenca: aluno.presenca ?? true,
        observacao: appendObs(
          observacaoAutomatica,
          aluno.observacoes
        )
      };
    });

    /* ======================
     * Histórico de chamadas
     * ====================== */
    const respCh = await axios.get(
      `/operacional/chamadas/historico`,
      { params }
    );

    chamadas.value = respCh.data.chamadas || [];
  } catch (e) {
    console.error('Erro ao carregar dados da chamada:', e);
  }
}

// Reage a mudanças do id e evita crash quando vier undefined/null
watch(
  () => props.id,
  (uid) => {
    details.value = parseUniqueId(uid);
    if (!details.value) {
      // Se o id vier inválido (p.ex. clique correu antes de mapear uniqueId), apenas feche o modal
      emit('fechar');
      return;
    }
    loadDadosChamada();
  },
  { immediate: true }
);
</script>

<style scoped>
/* ---- Modal base ---- */
.modal-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.5);
  z-index: 9999; display: flex; align-items: center; justify-content: center;
}
.modal-container {
  background: #fff; width: 80%; max-width: 80%; border-radius: 0px; overflow: hidden;
  max-height: 90vh; display: flex; flex-direction: column;
}
.modal-header { padding: 10px 15px; border-bottom: 1px solid #ddd; background: #f8f9fa; }
.modal-body   { padding: 12px; overflow: auto; }

/* ---- Tabelas e seções (mantive seu estilo) ---- */
.alunos-sections h6.table-title { font-family: inherit; font-size: 0.8rem; margin-bottom: 10px; }
.alunos-sections h6.experimental-title { color: green; }
.alunos-sections h6.avulsas-title { color: orange; }
.table { width: 100%; border-collapse: collapse; }
.table th, .table td { border: 1px solid #ddd; padding: 8px; text-align: left; }

.modal-table-scroll { max-height: 300px; overflow-y: auto; }
</style>
